import { render, staticRenderFns } from "./reservation-details.vue?vue&type=template&id=55d6499d&scoped=true&"
import script from "./reservation-details.vue?vue&type=script&lang=js&"
export * from "./reservation-details.vue?vue&type=script&lang=js&"
import style0 from "./reservation-details.vue?vue&type=style&index=0&id=55d6499d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d6499d",
  null
  
)

export default component.exports